import { HateoasResource, Resource } from "@lagoshny/ngx-hateoas-client";
import { BaseEntity } from "@app/models/rest/base-entity";
import { WorkGroup } from "@app/models/rest/work-group";
import { GroupMappingType } from "@app/models/enums/group-mapping-enum";

@HateoasResource("resourceGroups")
export class ResourceGroup extends BaseEntity {
  resource: Resource;
  workGroup: WorkGroup;
  groupMappingType: GroupMappingType;
}
